// DF HACCP SafeGuard — archivio locale del dispositivo (IndexedDB).
// "queue": registrazioni fatte senza connessione, finché il server non ne conferma il salvataggio.
// "cache": ultime risposte delle schermate necessarie per compilare i controlli offline.
// "meta": profilo minimo dell'utente collegato (nessuna password, PIN o firma).
const DB_NAME = "df-haccp-offline";
const VERSION = 1;
let dbPromise = null;

function open() {
  if (typeof indexedDB === "undefined") return Promise.reject(new Error("IndexedDB non disponibile"));
  if (!dbPromise) {
    dbPromise = new Promise((resolve, reject) => {
      const req = indexedDB.open(DB_NAME, VERSION);
      req.onupgradeneeded = () => {
        const db = req.result;
        if (!db.objectStoreNames.contains("queue")) db.createObjectStore("queue", { keyPath: "client_record_id" });
        if (!db.objectStoreNames.contains("cache")) db.createObjectStore("cache", { keyPath: "key" });
        if (!db.objectStoreNames.contains("meta")) db.createObjectStore("meta", { keyPath: "key" });
      };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => { dbPromise = null; reject(req.error); };
    });
  }
  return dbPromise;
}

function tx(store, mode, fn) {
  return open().then((db) => new Promise((resolve, reject) => {
    const t = db.transaction(store, mode);
    const s = t.objectStore(store);
    let result;
    Promise.resolve(fn(s)).then((r) => { result = r; });
    t.oncomplete = () => resolve(result);
    t.onerror = () => reject(t.error);
    t.onabort = () => reject(t.error);
  }));
}

const asPromise = (req) => new Promise((resolve, reject) => {
  req.onsuccess = () => resolve(req.result);
  req.onerror = () => reject(req.error);
});

export const putItem = (store, value) => tx(store, "readwrite", (s) => { s.put(value); });
export const getItem = (store, key) => open().then((db) => asPromise(db.transaction(store).objectStore(store).get(key)));
export const allItems = (store) => open().then((db) => asPromise(db.transaction(store).objectStore(store).getAll()));
export const deleteItem = (store, key) => tx(store, "readwrite", (s) => { s.delete(key); });
export const clearStore = (store) => tx(store, "readwrite", (s) => { s.clear(); });
